<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-sm-flex align-items-center">
                <a class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                    href="#" data-bs-toggle="modal" data-bs-target="#addBlacklistModal">
                    <i class="flaticon-plus position-relative ms-5 fs-12"></i>
                    Ajouter une liste noire
                </a>
            </div>

            <div class="d-flex align-items-center">
                <form class="search-box position-relative me-15" @submit.prevent="rechercher">
                    <input type="text" name="mot" v-model="searchTerm" @keyup="rechercher"
                        class="form-control shadow-none text-black rounded-0 border-0"
                        placeholder="Rechercher..." />
                    <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
                        <i class="flaticon-search-interface-symbol"></i>
                    </button>
                </form>
            </div>
        </div>

        <div class="card-body p-15 p-sm-20 p-md-25">
            <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0">Code liste</th>
                            <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0">Référence</th>
                            <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0">Type</th>
                            <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0">Motif</th>
                            <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0 text-end pe-0">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, index) in blacklists" :key="index">
                            <td class="fw-medium text-black-emphasis">{{ item.list_code }}</td>
                            <td class="fw-medium text-black-emphasis">{{ item.reference_value }}</td>
                            <td class="fw-medium text-black-emphasis">{{ item.entry_type }}</td>
                            <td class="fw-medium text-black-emphasis">{{ item.reason }}</td>

                            <td class="text-end pe-0">
                                <div class="dropdown">
                                    <span class="badge text-white bg-primary fs-15 dropdown-toggle"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        Actions
                                        <i class="flaticon-chevron-2 ms-5 fs-15"></i>
                                    </span>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <a class="dropdown-item d-flex align-items-center"
                                                href="javascript:void(0);" data-bs-toggle="modal"
                                                data-bs-target="#addBlacklistModal" @click="moddifier(item)">
                                                <i class="flaticon-pen me-8"></i> Modifier
                                            </a>
                                        </li>

                                        <li>
                                            <a class="dropdown-item d-flex align-items-center"
                                                href="javascript:void(0);"
                                                @click="suppression(item.id, blacklists, 'regulatory-blacklists', 'blacklist')">
                                                <i class="flaticon-delete me-8"></i> Supprimer
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>

            <div class="pagination-area d-md-flex mt-15 justify-content-between align-items-center">
                <PaginationComponent
                    :page="page"
                    :totalPages="totalPages"
                    :totalElements="totalElements"
                    :limit="limit"
                    @paginate="handlePaginate"
                />
            </div>
        </div>
    </div>

    <AddBlacklistModal :item="selectedItem" @close="recharger"/>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "../../services/ApiService";
import PaginationComponent from "../../components/Utilities/Pagination.vue";
import { suppression, error } from "../../utils/utils";
import AddBlacklistModal from "./AddBlacklistModal.vue";
import { RegulatoryBlacklists } from "@/models/RegulatoryBlacklists";

export default defineComponent({
    name: "ListeBlacklistPage",
    components: {
        PaginationComponent,
        AddBlacklistModal
    },

    setup() {
        const blacklists = ref<Array<RegulatoryBlacklists>>([]);
        const selectedItem = ref(0);

        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        function getAllBlacklists(page_ = 1, limit_ = 10, mot = '') {
            return ApiService.get(`all/regulatories?page=${page_}&limit=${limit_}&mot=${mot}&`)
                .then(({ data }) => {
                    console.log("doneeee",data);
                    blacklists.value = data.data.data;
                    totalPages.value = data.data.totalPages;
                    limit.value = data.data.limit;
                    totalElements.value = data.data.totalElements;
                })
                .catch(({ response }) => error(response.data.message));
        }

        function rechercher() {
            getAllBlacklists(page.value, limit.value, searchTerm.value);
        }

        const handlePaginate = ({ page_, limit_ }) => {
            page.value = page_;
            getAllBlacklists(page_, limit_, searchTerm.value);
        };

        function moddifier(item: RegulatoryBlacklists) {
            selectedItem.value = item.id;
        }

        function recharger() {
            getAllBlacklists();
        }

        onMounted(() => {
            getAllBlacklists();
        });

        return {
            blacklists,
            suppression,
            page,
            limit,
            totalPages,
            totalElements,
            searchTerm,
            rechercher,
            handlePaginate,
            selectedItem,
            recharger,
            moddifier
           
        };
    }
});
</script>
